import React from 'react';
import '../styles/Home.css';
import '../styles/HomeServices.css';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const HomeServices = () => {
  return (
    <div>
      <div className="financial">
        <div className="financial-continer">
          <h1 className="financial-head">Our Tax & Financial Services</h1>
          <p className="financial-para">
            We provide expert tax planning, compliance, and advisory solutions tailored for individuals and businesses.
          </p>
        </div>

        <div className="financial-container-two">
          {/* 1 */}
          <Link to="/services?category=registration&service=gst" className="grid-item-link">
            <div className="grid-item">
              <div className="grid-item-inner">
                <div className="grid-list-wrapper">
                  <div className="grid-list">
                    <div className="double-rec">
                      <h1 className="double-rec-one">
                        <span> Registrations / <br />License</span>
                      </h1>
                    </div>

                    <p className="grid-list-para">
                      Our team can handle all your registrations and licensing needs ensuring your business is fully
                    </p>

                    <div className="tax-icon">
                      <img src="./images/home/banner/licensing.png" alt="service1 not found" />
                    </div>

                    <FaArrowRight className="service-arrow-icon bottom-right-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {/* 2 */}
          <Link to="/services?category=filings&service=gst-filing" className="grid-item-link">
            <div className="grid-item">
              <div className="grid-item-inner">
                <div className="grid-list-wrapper">
                  <div className="grid-list">
                    <div className="double-rec">
                      <h1 className="double-rec-one">Filings</h1>
                    </div>

                    <p className="grid-list-para">
                      We manage all your business filings from formation documents to compliance updates with speed and accuracy
                    </p>

                    <div className="tax-icon">
                      <img src="./images/home/banner/e-way-bill.png" alt="service1 not found" />
                    </div>

                    <FaArrowRight className="service-arrow-icon bottom-right-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {/* 3 */}
          <Link to="/services?category=auditing&service=internal" className="grid-item-link">
            <div className="grid-item">
              <div className="grid-item-inner">
                <div className="grid-list-wrapper">
                  <div className="grid-list">
                    <div className="double-rec">
                      <h1 className="double-rec-one">Auditing</h1>
                    </div>

                    <p className="grid-list-para">
                      We provide thorough auditing services to ensure your financial records are accurate and compliant.
                    </p>

                    <div className="tax-icon">
                      <img src="./images/home/banner/audit.png" alt="service1 not found" />
                    </div>

                    <FaArrowRight className="service-arrow-icon bottom-right-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {/* 4 */}
          <Link to="/services?category=certification&service=networth" className="grid-item-link">
            <div className="grid-item">
              <div className="grid-item-inner">
                <div className="grid-list-wrapper">
                  <div className="grid-list">
                    <div className="double-rec">
                      <h1 className="double-rec-one">Certification</h1>
                    </div>

                    <p className="grid-list-para">
                      We assist with all your business certification needs, helping you meet industry standards and build credibility.
                    </p>

                    <div className="tax-icon">
                      <img src="./images/home/banner/contract.png" alt="service1 not found" />
                    </div>

                    <FaArrowRight className="service-arrow-icon bottom-right-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {/* 5 */}
          <Link to="/services?category=others&service=gst" className="grid-item-link">
            <div className="grid-item">
              <div className="grid-item-inner">
                <div className="grid-list-wrapper">
                  <div className="grid-list">
                    <div className="double-rec">
                      <h1 className="double-rec-one">Others</h1>
                    </div>

                    <p className="grid-list-para">
                      Our team can handle all your registrations and licensing needs ensuring your business is fully
                    </p>

                    <FaArrowRight className="service-arrow-icon bottom-right-arrow" />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeServices;
